import * as z from "zod/v4";

export const getPayoutInvoiceCsv = {
  name: "getPayoutInvoiceCsv" as const,
  input: z.object({ teamId: z.string(), payoutId: z.string() }),
  output: z.object({ url: z.string() }),
};
